/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import { Api } from '@/services/Api'

export default {
  getScbData(param) {
    return Api().post('/api/v1.0/scb-data', param)
  },
  getStringData(param) {
    return Api().post('/api/v1.0/scb-string', param)
  },
  getChannelData(param) {
    return Api().post('/api/v1.0/scb-channel', param)
  },
  getStingInverterData(param) {
    return Api().post('/api/v1.0/string-inverters/channel-table', param)
  },
  getAdvancedStingInverterData(param, type, date) {
    return Api().get(`/api/v1.0/stringInv/${param}/${type}/${date}`)
  },
  getStringDataGraph(param) {
    return Api().post('/api/v1.0/string-inverters/channel-graph', param)
  },
  getStringPowerDataGraph(param) {
    return Api().post('/api/v1.0/string-inverters/channel-power-graph', param)
  },
  getStringVoltageDataGraph(param) {
    return Api().post('/api/v1.0/string-inverters/channel-voltage-graph', param)
  },
  getScbStatus(plantId) {
    return Api().get(`/api/v1.0/scbStatus/${plantId}`)
  },
  getConnectedScbStatus(plantId) {
    return Api().get(`/api/v1.0/scbStatus/connected/${plantId}`)
  }
}
